import React, { Component } from "react";
import {  Tabs, Input,} from "antd";
import AsignCard from "../../components/Card/Assign";
import ViewCard from "../../components/Card/Assign/ViewCard";
import searchIcon from "../../assets/images/searchicon.svg";
import patientIcon from "../../assets/images/Patient.svg";
import moment from "moment";
import { UserOutlined,UserSwitchOutlined } from '@ant-design/icons';
import { InfoCircleOutlined,HourglassOutlined,CheckCircleOutlined ,DatabaseOutlined } from '@ant-design/icons';
import './index.scss';
import postService from "../../services/httpService";
import userTrackService from "../../services/usertrack-service";
import { Popover, Button, Modal, Select } from "antd";
import Storage from "../../services/local-store";
import "./../../index.scss";
import {socket} from './../../components/Card/Assign/index';




const { TabPane } = Tabs;
const { Search } = Input;


class TabView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ModalText: "Content of the modal",
      clicked: false,
      roomchangemodalvisible: false,
      stateRoomChangeReason: "",
      stateRoomNumber: "",
      ModalError: false,
      ModalError1: false,
      confirmLoading: false,
      warningmodalvisible: false,
      noroomsmodalvisible:false,
      ModalData:"",
      rooms:[],
      roomTransferReasonsforDropdown:[],
    };
  }
  
  handleBreakTime(break_start_time){
    const breakStartTime =break_start_time ;
    const currentTime = new Date().toISOString(); // Current time
    
    // Calculate the difference in minutes
    const startTime = new Date(breakStartTime);
    const endTime = new Date(currentTime);
    const diffInMs = endTime - startTime;
    const diffInHours = Math.floor(diffInMs / 1000 / 60 / 60);
const diffInMinutes = Math.floor((diffInMs / 1000 / 60) % 60);
    return<p>{diffInHours}:{diffInMinutes}</p>
  }

  stopBreakHandler(item){
    let obj = {
      queuelistid: item.queuelistid,
      queue_doctor_id: item.queue_doctor_id,
    };
console.log("onclick",item.queuelistid,item.queue_doctor_id);
let Userlogobj = {
  user: JSON.parse(Storage.get("user")),
  action: "drag and drop",
  date: new Date(),
  meta: obj,
};
userTrackService(Userlogobj);
postService("updateBreakStatusTime", "POST", { data: obj }).then(
  (res) => {
    let Userlogobjres = {
      user: JSON.parse(Storage.get("user")),
      action: "drag and drop - response",
      date: new Date(),
      meta: res,
    };
    userTrackService(Userlogobjres);
    //this.setState({ isLoading: false });
    //if (res) {
      if (socket.readyState === WebSocket.OPEN) {
      // this.onStartQ(queueitem, "withoutassign")
         const jsonString = JSON.stringify({data:"doctorbreak"});
        socket.send(jsonString);
      };
   //this.props.refreshData();
    // console.log("stoppppppppppppppppp")
    // if (socket.readyState === WebSocket.OPEN) {
      //   // this.onStartQ(queueitem, "withoutassign")
    //   const jsonString = JSON.stringify(obj);
    //   socket.send(jsonString);
    // };
    // this.props.refreshSingleQueue(obj, "RefreshQueueAfterBreak");
  })}
  showRoomChangeModal = () => {
    this.setState({
      roomchangemodalvisible: true,
      stateRoomChangeReason: "",
      stateRoomNumber: "",
      ModalError: false,
      ModalError1: false,
    });
  };
 
  roomchangehandleCancel = () => {
    this.setState({
      roomchangemodalvisible: false,
    });
  };
  warningmodalhandleOk = () => {
    this.setState({warningmodalvisible: false})
  }
  noroomsmodalhandleOk = () => {
    this.setState({noroomsmodalvisible: false})
  }
  roomchangehandleOk = () => {
    this.setState({
      confirmLoading: false,
      roomchangemodalvisible: false,
    });
  };
  getRoomChangeReason(value) {
    this.setState({ stateRoomChangeReason: value });
  }
  getRoomNumber(value) {
    this.setState({ stateRoomNumber: value });
  }
  serviceCallForRoomChange() {
    if (this.state.stateRoomChangeReason == "" ){
      this.setState({ ModalError: true });}
    else if(this.state.stateRoomNumber == ""){
      this.setState({ ModalError1: true }); }
    else{
      const new_doctor_data=this.state.rooms.filter(item=>item.quelist_id==this.state.stateRoomNumber);
      this.setState({ roomchangemodalvisible: false });

      let patient_ids = this.props.displayPatients
  .filter(item => item.id) 
  .map(item =>item.id);

   
       let currentObj = this.props.item;
       this.props.activateLoader();
       let obj = {
        patient_ids: patient_ids||[],
        room_transfer_done_by: JSON.parse(Storage.get("user")),
        status: true,
        unit_id:new_doctor_data[0].unit_id||"",
        new_queuelistid:this.state.stateRoomNumber||"",
        new_doctor_name:new_doctor_data[0].doctor_name||"",
        new_doctor_id:new_doctor_data[0].doctor_id||"",
        queuelistid: this.props.queueitem.queuelistid || "",
        old_doctor_name:this.props.queueitem.doctorname ||"",
        old_doctor_id:this.props.queueitem.queue_doctor_id||"",
      reason: this.state.stateRoomChangeReason || "",
      };
     
      let Userlogobj = {
        user: JSON.parse(Storage.get("user")),
        action: "Allow patient to different room",
        date: new Date(),
        meta: obj, 
      };
       userTrackService(Userlogobj);
      
      postService("allowPatientBetweenRooms", "POST", { data: obj }).then(
        (res) => {
          let Userlogobjres = {
            user: JSON.parse(Storage.get("user")),
            action: "Allow patient to different room- response",
            date: new Date(),
            meta: res,
          };
          userTrackService(Userlogobjres);
          //this.props.refreshData();
          if (socket.readyState === WebSocket.OPEN) {
            console.log('WebSocket connection established Checkin Checkin.');
            // this.onStartQ(queueitem, "withoutassign")
            const jsonString = JSON.stringify({data:"queuetransfer"});
            socket.send(jsonString);
          };
          //this.props.refreshSingleQueue(obj, "fromroomChange");
      //     let obj1 = {
      //       patientId: currentObj.id,
      //       status: true,
      //       queuelistid:this.state.stateRoomNumber||"",
      //       roomnumber: this.props.queueitem.roomnumber || "",
      //     reason: this.state.stateRoomChangeReason || "",
      //     };
      //     let Userlogobj1 = {
      //   user: JSON.parse(Storage.get("user")),
      //   action: "Allow patient to different room",
      //   date: new Date(),
      //   meta: obj1,
      // };
      // userTrackService(Userlogobj1);
      //      this.props.refreshSingleQueue(obj1, "toroomChange");
        }
      );
   
  }}
  hide = () => {
    this.setState({
      clicked: false,
    });
  };
  renderTime(date) {
    return moment(date).format("hh:mm A");
  }
  getRoomTransferReasonsforDropdown() {
    postService("getRoomChangeReasons", "GET", "").then((res) => {
      if (res.status) {
        this.setState({ roomTransferReasonsforDropdown: res.data });
      }
    });
  }
  transferQueue(){
  
    let dept_id="";
    this.props.department_ids.map(item=>{
      if(item.doctor_id == this.props.queueitem.queue_doctor_id){
        dept_id=item.dept_ids[0];
      }
    })
  console.log("dept_ids",dept_id, this.props.department_ids);
    const rooms=this.props.department_ids.filter( item=>
      item.dept_ids && item.doctor_name && item.doctor_id!=this.props.queueitem.queue_doctor_id && item.dept_ids.includes(dept_id)
      );

   
    if(rooms){
this.setState({rooms:rooms});
    }
      let checkoutpatients=this.props.displayPatients.filter(item=>item.current_workflow_stage_id==='4');
   if(this.props.displayPatients && this.props.displayPatients.length<1){
    this.setState({ModalData:"No patients are avaiable for queue transfer"})
    this.setState({ warningmodalvisible: true });
  }
     else if(checkoutpatients && checkoutpatients.length>0){
      this.setState({ warningmodalvisible: true });
    this.setState({ModalData:"Before transferring the queue, complete the procedure for the existing patient or remove the patient from the queue."
      
    })}
  else if(rooms && rooms.length==0){
    this.setState({ noroomsmodalvisible: true });
  }
  else{
   this.setState({ ModalText: "Choose the reason for changing room" });
    this.hide();
    this.showRoomChangeModal();
    this.getRoomTransferReasonsforDropdown();
   
    

  }
    }

  tabView = (tab, tabList) => {

    //console.log("tab list",tabList,this.props.queueitem);
    let that = this;
    // const { queueitem, displayPatients, slug, roomId } = this.props;
    const { queueitem, displayPatients, slug, roomId, } = this.props;
  
   //console.log('II',this.props.item.doctor_break_status);
    let patientsCount = tabList && tabList.filter((value) => value.is_investigation === null).length;
    // if(patientsCount== undefined){
    //   patientsCount=0;
    // }
    
    return (
      
      <TabPane
        tab={
          <span>
            <Popover
              overlayClassName="popover-custom"
              placement="top"
              title={""}
              content={tab.title}
              
      >
            
              {tab.icon_type=='hourglass'?<HourglassOutlined  style={{ verticalAlign: 'text-top', }} />:tab.icon_type=='check-circle'?<CheckCircleOutlined  style={{ verticalAlign: 'text-top',marginRight:'5px' }} />:<DatabaseOutlined  style={{ verticalAlign: 'text-top' ,marginRight:'5px'}} />}

              {tab.text}
              {/* {tabList && tabList.length ? ` (`+tabList.length+`)` : " (0)"} */}
              {`(`+patientsCount+`)`}
            </Popover>
          </span>
        }
        key={tab.key}
      >
        <div className="row mb-2 pr-2" >
          
          {tab.key === 1 ? (
            <div className="col-8 pr-0" >
              <Search
                placeholder="Search here"
                value={this.props.searchVal}
                allowClear={true}
                onChange={(e) =>
                  this.props.getSearchResults(e.target.value, "in-progress")
                }
              />
            </div>
          ) : tab.key === 2 ? (
            <div className="col-10 pr-0">
              <Search
                placeholder="Completed Search here"
                value={this.props.searchVal}
                allowClear={true}
                onChange={(e) =>
                  this.props.getSearchResults(e.target.value, "completed")
                }
              />
            </div>
          ) : (
            <div className="col-10 pr-0">
              <Search
                placeholder="Search here"
                value={this.props.searchVal}
                allowClear={true}
                onChange={(e) =>
                  this.props.getSearchResults(e.target.value, "total")
                }
              />
            </div>
          )}
          
          <Popover
            overlayClassName="popover-custom"
            placement="top"
            title={""}
            content={"Refresh"}
          >
            <figure
              className="col py-1 pr-0 mb-0 text-left"
              onClick={() =>{
                if (socket.readyState === WebSocket.OPEN) {
                  console.log('WebSocket connection established ++Rebuild.');
                  // this.onStartQ(queueitem, "withoutassign")
                  const jsonString = JSON.stringify({data:queueitem,action:"manualReafresh"});
                  socket.send(jsonString);
                };}
                //this.props.refreshSingleQueue(queueitem, "manualRefresh")
              }
            >
             <img
                src="/assets/images/icons/refresh.png"
                alt="refresh"
                draggable={false}
              />
            </figure>
          </Popover>
          {tab.key === 1 && (
            <Popover
              overlayClassName="popover-custom"
              placement="topRight"
              title={""}
              content={"Transfer Queue"}
            >
              <figure
           
                className="col py-1 pl-0 mb-0 text-center"
                // onClick={this.transferQueue.bind(this)}
              >
               
               <UserSwitchOutlined  onClick={this.transferQueue.bind(this)} style={{display:"absolute",color:"#6e7881",fontSize:"16px",marginLeft:"13px",marginTop:"3px"}}/>
              </figure>
            </Popover>
          )}
          <Modal
                visible={this.state.roomchangemodalvisible}
                onOk={this.roomchangehandleOk}
                confirmLoading={this.state.confirmLoading}
                onCancel={this.roomchangehandleCancel}
                footer={null}
              >
                <p>{this.state.ModalText}</p>
                <div className="col-12 mb-3">
                  {this.state.ModalError ? (
                    <small className="text-danger">
                      Please select the reason.
                    </small>
                  ) : (
                    ""
                  )}
                  <Select
                    value={this.state.stateRoomChangeReason}
                    style={{ width: "100%" }}
                    onChange={this.getRoomChangeReason.bind(this)}
                  >
                      <Select.Option value="">Select the Reason</Select.Option>
                    {this.state.roomTransferReasonsforDropdown.map((d, i) => {
                      return (
                        <Select.Option value={d.id} key={i}>
                          {d.reason}
                        </Select.Option>)})}
                      
                  </Select>
                  <p></p>
                  {this.state.ModalError1 ? (
                    <small className="text-danger">
                      Please select the Room.
                    </small>
                  ) : (
                    ""
                  )}
                  <Select
                    value={this.state.stateRoomNumber}
                    style={{ width: "100%" }}
                    onChange={this.getRoomNumber.bind(this)}
                  >
                    <Select.Option value="">Select Room Number</Select.Option>
                    {this.state.rooms.map((d, i) => {
                      return (
                        <Select.Option value={d.quelist_id} key={i}>
                          {d.roomnumber}
                        </Select.Option>)})}
                      
                  </Select>
                </div>
                <Button
                  type="primary"
                  onClick={this.serviceCallForRoomChange.bind(this)}
                >
                  Submit
                </Button>
              </Modal>
              <Modal
          style={{ top: "25%" }}
          visible={this.state.warningmodalvisible}
          onOk={this.warningmodalhandleOk}
          confirmLoading={this.state.confirmLoading}
          footer={[
            <Button type="primary" onClick={this.warningmodalhandleOk}>
              Ok
            </Button>,
          ]}
        >
          <p className="mt-3"> {this.state.ModalData}</p>
        </Modal>
        <Modal
          style={{ top: "25%" }}
          visible={this.state.noroomsmodalvisible}
          onOk={this.noroomsmodalhandleOk}
          confirmLoading={this.state.confirmLoading}
          footer={[
            <Button type="primary" onClick={this.noroomsmodalhandleOk}>
              Ok
            </Button>,
          ]}
        >
          <p className="mt-3"> No rooms are available for queue transfer  </p>
        </Modal>
          {tab.key === 1 && (
            <Popover
              overlayClassName="popover-custom"
              placement="topRight"
              title={""}
              content={"Reset Queue"}
            >
              <figure
                className="col py-1 pl-0 mb-0 text-center"
                onClick={() => this.props.checkReBuildQ(queueitem, that)}
              >
                <img
                  src="/assets/images/icons/re_build.png"
                  alt="rebuild"
                  draggable={false}
                />
              </figure>
            </Popover>
          )}
        </div>
{this.props.item != undefined && this.props.item && this.props.item.doctor_break_status!= undefined &&this.props.item.doctor_break_status && this.props.item.doctor_break_status=='1'?(
tab.key==1?(
  <div style={{justifyContent: 'center', alignItems: 'center' ,borderRadius:"10px",backgroundColor:"lightgray"}}>
                     <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                       <div style={{ fontSize: '20px', marginRight: '10px',padding:"20px 0px" }}>Doctor On Break</div>
                       {/* <div style={{marginTop:"19px"}}>{this.handleBreakTime(this.props.item.break_start_time)}</div> */}
                       </div>
                       
                        <center>
                       <button className="custom-btn" style={{fontSize:"14px"}}  onClick={this.stopBreakHandler.bind(this,this.props.item)}>
                        Stop
                       
                       </button>
                       </center>
                     
                   </div>
):(
  tabList && tabList.map((item, index) => {
    let previous_patient_service_time = 0;
    let service_time, slottime;
    tabList.map((s, u) => {
      if (u < index) {
        let kservicetime = s.service_time || 0;
        previous_patient_service_time =
          parseInt(previous_patient_service_time) +
          parseInt(kservicetime);
      }
    });
    service_time = previous_patient_service_time;
    var dt = new Date();
    dt.setMinutes(dt.getMinutes() + service_time);
    slottime = this.props.formatAMPM(dt);
    item.roomnumber = roomId;
    if (tab.key == 2 || tab.key==3) {
  return (
    <ViewCard
      {...this.props}
      item={item}
      tabList={tabList}
      singleQueueList={[tabList]}
      itemindex={index}
      refreshData={this.props.refreshData.bind(this)}
      slottime={slottime}
      fullslottime={dt}
      key={index}
      activateLoader={this.props.activateLoader.bind(this)}
      deActivateLoader={this.props.deActivateLoader.bind(this)}
      refreshSingleQueue={this.props.refreshSingleQueue.bind(this)}
      isvitalsRequire_nullornot={this.props.isvitalsRequire_nullornot.bind(
        this
      )}
    />
  );
}}))

):(
        tabList && tabList.map((item, index) => {
          let previous_patient_service_time = 0;
          let service_time, slottime;
          tabList.map((s, u) => {
            if (u < index) {
              let kservicetime = s.service_time || 0;
              previous_patient_service_time =
                parseInt(previous_patient_service_time) +
                parseInt(kservicetime);
            }
          });
          service_time = previous_patient_service_time;
          var dt = new Date();
          dt.setMinutes(dt.getMinutes() + service_time);
          slottime = this.props.formatAMPM(dt);
          item.roomnumber = roomId;
          if (tab.key == 1) {
            return (
              <div>
             
              <AsignCard
                {...this.props}
                item={item}
                tabList={tabList}
                tabKey={tab.key}
                singleQueueList={[queueitem]}
                itemindex={index}
                refreshData={this.props.refreshData.bind(this)}
                slottime={slottime}
                fullslottime={dt}
                key={index}
                activateLoader={this.props.activateLoader.bind(this)}
                deActivateLoader={this.props.deActivateLoader.bind(this)}
                refreshSingleQueue={this.props.refreshSingleQueue.bind(this)}
                isvitalsRequire_nullornot={this.props.isvitalsRequire_nullornot.bind(
                  this
                )}
                onChange={(e) =>
                  this.props.getSearchResults(e.target.value, "in-progress")
                }
              /></div>
            );
          }
           else {
            return (
              <ViewCard
                {...this.props}
                item={item}
                tabList={tabList}
                singleQueueList={[tabList]}
                itemindex={index}
                refreshData={this.props.refreshData.bind(this)}
                slottime={slottime}
                fullslottime={dt}
                key={index}
                activateLoader={this.props.activateLoader.bind(this)}
                deActivateLoader={this.props.deActivateLoader.bind(this)}
                refreshSingleQueue={this.props.refreshSingleQueue.bind(this)}
                isvitalsRequire_nullornot={this.props.isvitalsRequire_nullornot.bind(
                  this
                )}
              />
            );
          }
        }))}
      </TabPane>
    );
  };

  patientCard(list, item, itemindex, tab_key) {
    this.state.currentObj = item;

    const patient_details = item && (
      <div>
        <p className="mb-0">
          Service : {item.service_name ? item.service_name : "--"}
        </p>
        <p className="mb-0">
          Mobile No : {item.phonenumber ? item.phonenumber : "--"}
        </p>
        <p className="mb-0">
          Vitals Required :{" "}
          {item.is_vitals_require !== null ? item.is_vitals_require : "--"}
        </p>
        <p className="mb-0">
          Vitals Status :{" "}
          {item.is_vitals_require === "YES"
            ? item.is_vitals_done !== null
              ? item.is_vitals_done === "YES"
                ? "Done"
                : "Not yet done"
              : "Patient in Vitals Queue"
            : "--"}
        </p>
      </div>
    );
    const popupContent = (
      <div className="popup">
        <h4>
          More Options 
          <img
            onClick={this.props.hide}
            src="/assets/images/icons/popup-close.png"
            alt="closeicon"
          />
        </h4>
        <div className="row">
          <div className="col">
            <Button
              className="btn-magenta mx-0"
              onClick={this.props.skipPatientFromQueue.bind(this, item)}
            >
              Skip
            </Button>
          </div>
        </div>
      </div>
    );

    if(tab_key == 1){
      return(<div
        class={`pl-2 pr-1 ${
          item.is_investigation ? "pb-1" : "py-1"
        } my-2 mr-1 b-card-body disable-text`}
      >
        {/* {item.is_investigation && (
          <small className="text-danger ml-1">Investigation</small>
        )} */}
        <div className="row">
          <p className="text-p-light col-7 pl-1">
            <img alt="" src={patientIcon} class="patientIcon" />
            {item.name}
          </p>
          <div class="col-5 text-right">
            <span class="time m-auto">
              {"WT: "}
              {item.waitingTAT}
            </span>
          </div>
        </div>

        <div className="row">
          <p className="text-p-light col-7 my-auto">
            <Popover
              overlayClassName="popover-custom"
              content={patient_details}
              title=""
            >
              {/* <Icon
                type="info-circle"
                style={{
                  color: "#ac7ab0",
                  transform: "rotate(0deg)",
                  fontSize: "15px",
                  margin: "0 6px 0 -2px",
                }}
              /> */}
             
              <InfoCircleOutlined
  style={{
    color: '#ac7ab0',
    transform: 'rotate(0deg)',
    fontSize: '15px',
    margin: '0 6px 0 -2px',
    
  }}
/>
            </Popover>
            {item.umr ? item.umr : "--"}
          </p>
          <div class="col-5">
            <div
              className="status m-0 mr-1"
              style={{ float: "right", width: "fit-content" }}
            >
              {item && item.status === "3" && tab_key == 1 ? (
                <button
                  className={
                    item.bill_cancel_status == "YES"
                      ? "text-cancelled-disable"
                      : "btn-magenta w-100 p-1"
                  }
                  onClick={this.props.changePatientStatustoCheckin.bind(
                    this,
                    "checkin",
                    item
                  )}
                  disabled={
                    (item.bill_cancel_status == "YES" ||
                      (item.is_vitals_require === "YES" &&
                        item.is_vitals_done !== "YES")) &&
                    true
                  }
                >
                  {item.bill_cancel_status == "YES"
                    ? "BIL-CAN"
                    : item.is_vitals_require === "YES"
                    ? item.is_vitals_done === "YES"
                      ? "C-IN"
                      : "VITALS"
                    : "C-IN"}
                </button>
              ) : item && item.status === "4" && tab_key == 3 ? (
                <span className="Patientname ml-0"></span>
              ) : item && item.status === "4" && tab_key == 1 ? (
                <button
                  className="btn-red w-100 p-1"
                  onClick={this.props.onDoctorCheckout.bind(this, item)}
                >
                  C-OUT
                </button>
              ) : item && item.status === "5" ? (
                <span className="Patientname ml-0">
                  C-IN:{"\u00a0"}
                  {this.renderTime(item.checkin_time) !== "Invalid date"
                    ? this.renderTime(item.checkin_time)
                    : "HH:MM"}
                </span>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>

        <div className="row">
          <div className={item.appointment_date !== null ? "col-4" : "col-10"}>
            <span className="Patientname ml-0">
              {/* {item.arrivaltime ? item.arrivaltime : "--"}{" "} */}
              Arr: {"\u00a0"}
              {this.renderTime(item.arrivaltime) !== "Invalid date"
                ? this.renderTime(item.arrivaltime)
                : "HH:MM"}
            </span>
          </div>
          {item.appointment_date && (
            <div className="col-5">
              <span className="Patientname ml-0">
                {/* {item.arrivaltime ? item.arrivaltime : "--"}{" "} */}
                Apt: {"\u00a0"}
                {this.renderTime(item.appointment_date) !== "Invalid date"
                  ? this.renderTime(item.appointment_date)
                  : "HH:MM"}
              </span>
            </div>
          )}

          {tab_key == 1 && (
            <div className="col-2 my-auto">
              <p className="text-right text-p-bold">
                {/* asd4 */}
                {(list.length - 1 !== itemindex || list.length === 1) && (
                  <Popover
                    placement="bottomLeft"
                    content={popupContent}
                    trigger="click"
                    visible={
                      item.id === this.props.handleClickChangeID
                        ? this.props.popupclicked
                        : false
                    }
                    onVisibleChange={this.props.handleClickChange.bind(
                      this,
                      item.id
                    )}
                  >
                    <img
                    
                      src="/assets/images/icons/more-icon.png"
                      alt="more"
                      srcset=""
                      className=""
                    />
                  </Popover>
                )}
              </p>
            </div>
          )}
        </div>
      </div>)
    }
    if(tab_key != 1){
      let redLabel = false;

    return (
      <div
      
        className={`pr-0 pl-3 pt-1 disable-text ${
          redLabel ? "time-exceed" : ""
        } ${item.checkinskip == "1" ? "skipcolor" : ""}`}
      >
        {/* <div className="PatientCard mr-1 pb-2 h-auto"> */}
       
        <div className={item.checkout_time !== null ? 'PatientCard mr-1 pb-2 h-auto que-completed-patients' : 'PatientCard mr-1 pb-2 h-auto'}>
          <div className="col pl-0">
            {item.is_investigation && (
              <>
                <div className="row">
                  <div className="col-8">
                    {/* {item.is_investigation && (
                      <small className="text-danger ml-2">Investigation</small>
                    )} */}
                  </div>
                </div>
              </>
            )}
            <div
              className={`row ${!item.is_investigation && "mt-2"
              }`}
            >
              <div className="col-8 pr-0 pl-4">
                <img
                  alt=""
                  src={patientIcon}
                  className="patientIcon ml-0"
                  draggable={false}
                />
                <span className="Patientname text-wrap">
                  {item.name ? item.name : ""}
                </span>
              </div>
              <div className="col-4 pr-1 text-left">
                <span className="Patientname align-bottom">
                  <b>WT:</b> {item.waitingTAT}
                </span>
              </div>
            </div>

            <div className="row mt-1 pl-2">
              <div className="col-8">
                <Popover
                  overlayClassName="popover-custom"
                  content={patient_details}
                  title=""
                >
                  {/* <Icon
                    type="info-circle"
                    style={{ color: "#ac7ab0" }}
                    className="uidIcon"
                  /> */}
                  <InfoCircleOutlined style={{ color: '#ac7ab0' }} className="uidIcon" />

                </Popover>
                <span className="PatientUid" style={{"vertical-align": "-webkit-baseline-middle;"}}>
                  {item.umr ? item.umr : ""} 
                </span>
              </div>
              <div className="col-4 ml-0">
                <span class="time m-auto">
                  {item.appointment_date && <span className="Patientname align-bottom ml-0">
                    <b>Apt:</b>
                    {"\u00a0"}{" "}
                    {this.renderTime(item.appointment_date) !== "Invalid date"
                      ? this.renderTime(item.appointment_date)
                      : ""}
                  </span>}
                </span>
              </div>
            </div>
            <div className="row pl-2">
              <div className="col-4 pr-0">
                {item.arrivaltime &&<span className="Patientname align-bottom ml-0">
                  <b>Arr:</b>
                  {"\u00a0"}
                  {this.renderTime(item.arrivaltime) !== "Invalid date"
                    ? this.renderTime(item.arrivaltime)
                    : ""}
                </span>}
              </div>
              <div className="col-4 pr-0 text-center">
                {item.checkin_time && <span className="Patientname align-bottom ml-0">
                  <b>CI:</b>
                  {"\u00a0"}
                  {this.renderTime(item.checkin_time) !== "Invalid date"
                    ? this.renderTime(item.checkin_time)
                    : ""}
                </span>}
              </div>
              <div className="col-4 pr-0">
                {item.checkout_time && <span className="Patientname align-bottom ml-0">
                  <b>CO:</b>
                  {"\u00a0"}
                  {this.renderTime(item.checkout_time) !== "Invalid date"
                    ? this.renderTime(item.checkout_time)
                    : ""}
                </span>}
              </div>
            </div>
          </div>
        </div>
        
      </div>
    );
    }
  }

  doctorTabView = (tab, list) => {
    let that = this;
    let patientsCount = 0;
    
    if(list != undefined){
      patientsCount = list.filter((value) => value.is_investigation === null).length;
    }
    
    return (
      <TabPane
        tab={
          <span>
            <Popover
              overlayClassName="popover-custom"
              placement="top"
              title={""}
              content={tab.title}
            >
              {/* <Icon
                type={tab.icon_type}
                style={{ "vertical-align": "text-top" }}
              /> */}
              {/* <UserOutlined style={{ verticalAlign: 'text-top' }} /> */}
              {tab.icon_type=='hourglass'?<HourglassOutlined  style={{ verticalAlign: 'text-top' }} />:tab.icon_type=='check-circle'?<CheckCircleOutlined  style={{ verticalAlign: 'text-top',marginRight:'5px' }} />:<DatabaseOutlined  style={{ verticalAlign: 'text-top' ,marginRight:'5px'}} />}


              {tab.text}
              {/* {list && list.length ? ` (`+list.length+`)` : " (0)"} */}
              {`(`+patientsCount+`)`}
            </Popover>
          </span>
        }
        key={tab.key}
      >
        <div className="row mb-2 pr-2">
          {tab.key === 1 ? (
            <div className="col-9 pr-0">
              <Search
                placeholder="Search here"
                value={this.props.searchVal}
                allowClear={true}
                onChange={(e) =>
                  this.props.getSearchResults(e.target.value, "in-progress")
                }
              />
            </div>
          ) : tab.key === 2 ? (
            <div className="col-10 pr-0">
              <Search
                placeholder="Completed Search here"
                value={this.props.searchVal}
                allowClear={true}
                onChange={(e) =>
                  this.props.getSearchResults(e.target.value, "completed")
                }
              />
            </div>
          ) : (
            <div className="col-10 pr-0">
              <Search
                placeholder="Search here"
                value={this.props.searchVal}
                allowClear={true}
                onChange={(e) =>
                  this.props.getSearchResults(e.target.value, "total")
                }
              />
            </div>
          )}

          {/* <div className={tab.key === 1 ? "col-9 pr-0" : "col-10 pr-0"}>
            <Search
              placeholder="Search here"
              value={this.props.searchVal}
              allowClear={true}
              onChange={(e) => this.props.getSearchResults(e.target.value)}
            />
          </div> */}
          <Popover
            overlayClassName="popover-custom"
            placement="top"
            title={""}
            content={"Refresh"}
          >
            <figure
              className="col py-1 pr-0 mb-0 text-left"
              onClick={() =>
                this.props.getDoctorQueuePatients(this, "manualRefresh")
              }
            >
              <img
                src="/assets/images/icons/refresh.png"
                alt="refresh"
                draggable={false}
              />
            </figure>
          </Popover>
          {tab.key === 1 && (
            <Popover
              overlayClassName="popover-custom"
              placement="topRight"
              title={""}
              content={"Reset Queue"}
            >
              <figure
                className="col py-1 pl-0 mb-0 text-center"
                onClick={() => this.props.checkReBuildQ(list, that)}
              >
                <img
                  src="/assets/images/icons/re_build.png"
                  alt="rebuild"
                  draggable={false}
                />
              </figure>
            </Popover>
          )}
        </div>
       
        {this.props.QRoomDetails && this.props.QRoomDetails.doctor_break_status != undefined && this.props.QRoomDetails.doctor_break_status && this.props.QRoomDetails.doctor_break_status=='1'?(
tab.key==1?(
  <div style={{justifyContent: 'center', alignItems: 'center' ,borderRadius:"10px",backgroundColor:"lightgray"}}>
                     <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                       <div style={{ fontSize: '20px', marginRight: '10px',padding:"20px 0px" }}>Doctor On Break</div>
                       {/* <div style={{marginTop:"19px"}}>{this.handleBreakTime(this.props.QRoomDetails.break_start_time)}</div>  */}
                       </div>
                       
                        <center>
                       <button className="custom-btn" style={{fontSize:"14px",border:"none",borderRadius:"5px",padding:"10px 20px"}}  onClick={this.stopBreakHandler.bind(this,this.props.QRoomDetails)}>
                        Stop 
                       
                       </button>
                       </center>
                     
                   </div>):(
                     list && list.length
                     ? list.map((patientlistItem, index) => {
                         return this.patientCard(list, patientlistItem, index, tab.key);
                       })
                     : ""
                   )
):( 

       list && list.length
          ? list.map((patientlistItem, index) => {
              return this.patientCard(list, patientlistItem, index, tab.key);
            })
          : ""
          )} 
      </TabPane>
    );
  };

  render() {
    const {
      tabContent,
      slug,
      list,
      queueitem,
      displayPatients,
      completedPatients,
      totalPatients,
    } = this.props;
    const{
      stateRoomChangeReason,
      roomchangemodalvisible,
      confirmLoading,
      stateRoomNumber,
      ModalError,
      ModalError1,
    } = this.state;
     // console.clear()
    
    return slug === "doctor-view" ? (
      <div>
      <Tabs defaultActiveKey="1" onTabClick={(e) => this.props.onTabClick(e)} className="doctorViewTabs">
        
        {tabContent.map((tab, key) => {
          let tabList =
            tab.key == 1
              ? list
              : tab.key == 2
              ? completedPatients
              : totalPatients;
          return this.doctorTabView(tab, tabList);
        })}
      </Tabs></div>
    ) : (
      <Tabs defaultActiveKey="1" onTabClick={(e) => this.props.onTabClick(e)} tabBarGutter={8}>
      
        {tabContent.map((tab, key) => {
          let tabList = [];
          tabList =
            tab.key == 1
              ? (tabList.patients = displayPatients)
              : tab.key == 2
              ? (tabList.patients = completedPatients)
              : (tabList.patients = totalPatients);
          return this.tabView(tab, tabList);
        })}
      </Tabs>
    );
  }
}

export default TabView;
